import Lyrics from './Lyrics';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getCurrentTrackLyrics } from 'state/Tracks/selectors';

export default connect(
  createStructuredSelector({ lyrics: getCurrentTrackLyrics }),
)(Lyrics);
